import { defineStore } from "pinia";

import { useProductsStore } from "./productsStore";

export const useMaterialLibraryStore = defineStore("materialLibraryStore", {
  state: () => ({
    isCreateFolder: false,
    isEditFolder: false,
    activeFolder: null,
    activeMaterial: {},
    folders: [],
    filteredFolders: [],
    panel: [],
    triggerGetProductsByFolder: 0,
    folderSearchInput: "",
  }),
  getters: {
    GET_FOLDERS_COUNT(state) {
      return state.folders?.length ? state.folders?.length : 0;
    },
  },
  actions: {
    setValue(keyValue) {
      if (keyValue?.key in this) {
        this[keyValue.key] = keyValue.value;
      }
    },
    createFolder(folder) {
      this.activeFolder = folder;
      if (!Array.isArray(this.folders)) {
        this.folders = [];
      }
      this.folders.push(folder);
      this.filteredFolders = this.folders;
      this.isCreateFolder = true;
      this.isEditFolder = false;
    },
    updateFolder(folder) {
      const index = this.folders.findIndex((f) => f.id === folder.id);

      if (index !== -1) {
        const oldFolder = this.folders[index];

        const updatedMaterials = [
          ...new Map(
            [...(folder.materials || []), ...(oldFolder.materials || [])].map((m) => [m.id, m])
          ).values(),
        ];

        this.folders.splice(index, 1, {
          ...oldFolder,
          ...folder,
          materials: updatedMaterials,
        });
      }
    },
    deleteFolder(folder_id) {
      if (folder_id === this.activeFolder?.id) {
        this.isCreateFolder = false;
        this.isEditFolder = false;
        this.activeFolder = null;
      }
      this.folders = this.folders.filter((item) => item.id !== folder_id);
    },
    addMaterialFolder(materials) {
      materials.forEach((_material) => {
        const { library_id } = _material;
        const folder = this.folders.find((folder) => folder.id === library_id);

        if (!folder) {
          console.warn(`Папка с id ${library_id} не найдена`);
          return;
        }

        if (!folder.materials) {
          folder.materials = [];
        }

        folder.materials.push(_material);
      });
    },
    updateMaterialFolder(material) {
      const { library_id, id } = material;
      const folder = this.folders.find((folder) => folder.id === library_id);
      if (!folder) {
        console.warn(`Папка с id ${library_id} не найден`);
        return;
      }
      const materialIndex = folder.materials.findIndex((mat) => mat.id === id);
      if (materialIndex === -1) {
        console.warn(`Материал с id ${id} не найден в папке ${library_id}`);
        return;
      }
      folder.materials.splice(materialIndex, 1, material);
    },
    changeMaterialFolder(material) {
      const { library_id, id, old_folder } = material;
      const oldFolder = this.folders.find((folder) => folder.id === old_folder);

      if (oldFolder) {
        oldFolder.materials = oldFolder.materials.filter((mat) => mat.id !== id);
      } else {
        console.warn(`Старая папка с id ${old_folder} не найдена`);
      }
      const newFolder = this.folders.find((folder) => folder.id === library_id);
      if (!newFolder) {
        console.warn(`Новая папка с id ${library_id} не найдена`);
        return;
      }
      newFolder.materials = [...newFolder.materials, material];
    },
    changePanel(search) {
      const folders = this.folders || [];

      if (search !== "") {
        const indexes = folders.reduce((result, folder, index) => {
          const materialMatch = folder.materials.some(
            (material) =>
              material.name.toLowerCase().includes(search.toLowerCase()) ||
              material.codename.toLowerCase().includes(search.toLowerCase())
          );

          if (materialMatch) {
            result.push(index);
          }

          return result;
        }, []);

        this.panel = indexes.length > 0 ? indexes : [];
      }
    },
    searchFolders(search) {
      const folders = this.folders || [];
      if (search !== "") {
        const searchQuery = search.toLowerCase();

        const filteredFolders = folders.reduce((result, folder) => {
          const folderMatch = folder.name.toLowerCase().includes(searchQuery);

          const filteredMaterials = folder.materials?.filter(
            (material) =>
              material.name.toLowerCase().includes(searchQuery) ||
              material.codename.toLowerCase().includes(searchQuery)
          );

          if (folderMatch && filteredMaterials?.length > 0) {
            result.push({ ...folder, materials: filteredMaterials });
          } else if (filteredMaterials?.length > 0) {
            result.push({ ...folder, materials: filteredMaterials });
          } else if (folderMatch) {
            result.push(folder);
          }

          return result;
        }, []);
        this.filteredFolders = filteredFolders;
      } else {
        this.filteredFolders = folders;
      }
    },
    activeMaterialAction(material) {
      this.activeMaterial = material;
    },
    closeEditFolder() {
      this.activeFolder = null;
      this.isEditFolder = false;
      this.isCreateFolder = false;
    },

    SET_VALUE(keyValue) {
      this.setValue(keyValue);
    },
    REMOVE_FOLDER_FROM_PRODUCTS(folderId) {
      const productsStore = useProductsStore();
      productsStore.removeFolderFromProducts(folderId);
    },
    CLOSE_EDIT_FOLDER() {
      this.closeEditFolder();
    },
    CREATE_FOLDER(folder) {
      this.createFolder(folder);
    },
    UPDATE_FOLDER(folder) {
      this.updateFolder(folder);
    },
    DELETE_FOLDER(folder_id) {
      this.deleteFolder(folder_id);
      const productsStore = useProductsStore();
      productsStore.removeFolderFromProducts(folder_id);
    },
    SET_ACTIVE_MATERIAL(material) {
      this.activeMaterialAction(material);
    },
    ADD_MATERIAL_FOLDER(material) {
      const materialsToAdd = Array.isArray(material) ? material : [material];
      this.addMaterialFolder(materialsToAdd);
    },
    UPDATE_MATERIAL_FOLDER(material) {
      this.updateMaterialFolder(material);
    },
    CHANGE_MATERIAL_FOLDER(material) {
      this.changeMaterialFolder(material);
    },
    SEARCH_FOLDER(search) {
      this.changePanel(search);
      this.searchFolders(search);
    },
  },
});

export default useMaterialLibraryStore;
